var _defs, _rect, _g, _text, _text2, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEvaluator(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 560,
    height: 320,
    viewBox: "0 0 560 320",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0A0B0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0B0D12"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "shadow",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 4,
    stdDeviation: 6,
    floodColor: "#000",
    floodOpacity: 0.5
  })), /*#__PURE__*/React.createElement("style", null, "\n      :root{\n        --ink:#EAF2FF; --muted:#9AA4B2; --stroke:#1E2330;\n        --buy:#4DA3FF; /* set to your live candle blue */\n        --sell:#FF5A5A; /* set to your live candle red  */\n        --green:#10B981; --amber:#F59E0B; --blue:#3B82F6;\n      }\n      text{font-family:Inter,system-ui}\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 560,
    height: 320,
    fill: "url(#bg)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(24,22)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 512,
    height: 40,
    rx: 8,
    fill: "#0F1218",
    stroke: "var(--stroke)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 14,
    y: 25,
    fill: "var(--muted)",
    fontSize: 12,
    fontWeight: 600
  }, "Base Prediction:"), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 10,
    rx: 10,
    ry: 10,
    width: 60,
    height: 20,
    fill: "var(--buy)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 158,
    y: 24,
    textAnchor: "middle",
    fill: "#0A0B0E",
    fontSize: 11,
    fontWeight: 800
  }, "BUY"), /*#__PURE__*/React.createElement("rect", {
    x: 194,
    y: 10,
    rx: 10,
    ry: 10,
    width: 60,
    height: 20,
    fill: "var(--sell)",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("text", {
    x: 224,
    y: 24,
    textAnchor: "middle",
    fill: "#FCECEC",
    fontSize: 11,
    fontWeight: 700,
    opacity: 0.5
  }, "SELL"))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 24,
    y: 88,
    fill: "var(--ink)",
    fontSize: 18,
    fontWeight: 700
  }, "AI Evaluation")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 24,
    y: 106,
    fill: "var(--muted)",
    fontSize: 12
  }, "initial \u2192 review \u2192 final")), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#shadow)",
    fontSize: 11,
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(24,124)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    rx: 10,
    ry: 10,
    width: 160,
    height: 76,
    fill: "#14161C",
    stroke: "var(--stroke)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 12,
    rx: 6,
    ry: 6,
    width: 62,
    height: 20,
    fill: "var(--blue)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 43,
    y: 26,
    textAnchor: "middle",
    fill: "#fff"
  }, "INITIAL"), /*#__PURE__*/React.createElement("text", {
    x: 12,
    y: 54,
    fill: "var(--muted)",
    fontWeight: 600
  }, "Low RR; within window.")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(200,114)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    rx: 10,
    ry: 10,
    width: 160,
    height: 96,
    fill: "#161920",
    stroke: "var(--stroke)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 12,
    rx: 6,
    ry: 6,
    width: 66,
    height: 20,
    fill: "var(--amber)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 45,
    y: 26,
    textAnchor: "middle",
    fill: "#fff"
  }, "REVIEW"), /*#__PURE__*/React.createElement("text", {
    x: 12,
    y: 54,
    fill: "var(--muted)",
    fontWeight: 600
  }, "Tighten SL near entry."), /*#__PURE__*/React.createElement("text", {
    x: 12,
    y: 72,
    fill: "var(--muted)",
    fontWeight: 600
  }, "No reversal signals.")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(376,104)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    rx: 10,
    ry: 10,
    width: 160,
    height: 116,
    fill: "#171B22",
    stroke: "var(--stroke)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 12,
    rx: 6,
    ry: 6,
    width: 60,
    height: 20,
    fill: "var(--green)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 42,
    y: 26,
    textAnchor: "middle",
    fill: "#fff"
  }, "FINAL"), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 12,
    rx: 8,
    ry: 8,
    width: 60,
    height: 22,
    fill: "#0F8F6E"
  }), /*#__PURE__*/React.createElement("text", {
    x: 118,
    y: 27,
    textAnchor: "middle",
    fill: "#EAF2FF",
    fontWeight: 800
  }, "HOLD"), /*#__PURE__*/React.createElement("text", {
    x: 12,
    y: 56,
    fill: "var(--muted)",
    fontWeight: 600
  }, "ADJUST SL \u2192 683.30"), /*#__PURE__*/React.createElement("text", {
    x: 12,
    y: 74,
    fill: "var(--muted)",
    fontWeight: 600
  }, "Within c_20 window"), /*#__PURE__*/React.createElement("text", {
    x: 12,
    y: 92,
    fill: "var(--muted)",
    fontWeight: 600
  }, "RR unchanged")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvaluator);
export default __webpack_public_path__ + "static/media/evaluator.0ba1c7047b6f4a1ff1877adeb411cfd3.svg";
export { ForwardRef as ReactComponent };